module.exports = new __parcel__URL__("entries.75c19d0a.svg").toString();